<template>
  <qx-card-form title="账期设置">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="160px"
    >
      <!-- 回单期限 -->
      <div slot="recive" slot-scope="prop">
        <div v-show="prop.form.settleType === '1' || prop.form.settleType === '2'">
          离场日期+
          <el-input class="inputBox" v-model="otherFormData.receiptPeriod" placeholder="请输入">
            <span slot="suffix" class="inputSlotText">天</span>
          </el-input>
        </div>
        <div v-show="prop.form.settleType === '3'">
          <el-input class="appendInputBox" v-model="otherFormData.reciveMonth" placeholder="请输入">
            <span slot="suffix">个月后
              <el-select
                class="inputAppendSelect"
                v-model="otherFormData.receiptPeriodDay"
                :clear="true"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in 31"
                  :key="item"
                  :label="item + '号'"
                  :value="item" />
              </el-select>
            </span>
          </el-input>
        </div>
      </div>
      <!-- 回单期限 end -->
      <!-- 收款期限 -->
      <div slot="collection" slot-scope="prop">
        <div v-show="prop.form.settleType === '2'">
          回单审核后+
          <el-input class="inputBox" v-model="otherFormData.payPeriod" placeholder="请输入">
            <span slot="suffix" class="inputSlotText">天</span>
          </el-input>
        </div>
        <div v-show="prop.form.settleType === '3'">
          <el-input class="appendInputBox" v-model="otherFormData.collectionMonth" placeholder="请输入">
            <span slot="suffix">个月后
              <el-select
                class="inputAppendSelect"
                slot="suffix"
                v-model="otherFormData.payPeriodDay"
                :clear="true"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in 31"
                  :key="item"
                  :label="item + '号'"
                  :value="item" />
              </el-select>
            </span>
          </el-input>
        </div>
      </div>
      <!-- 收款期限 end -->
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  getEnumList,
} from 'api';
export default {
  data () {
    return {
      otherFormData: {
        receiptPeriod: '', // 回单期限天数
        reciveMonth: '', // 回单期限第几个月
        receiptPeriodDay: '', // 回单期限第几号
        payPeriod: '', // 收款期限天数 payPeriod
        collectionMonth: '', // 收款期限第几个月
        payPeriodDay: '', // 收款期限第几号
      },
      baseForm: {
        settleTypeOptions: [],
        form: [
          {
            label: '结算方式',
            value: 'settleType',
            type: 'select',
            width: '240px',
            onChange: () => {
              this.handleLabelTypeChange();
            },
          },
          {
            label: '回单期限',
            value: 'recive',
            slot: true,
          },
          {
            label: '收款期限',
            value: 'collection',
            slot: true,
            hide: false,
          },
        ],
        rules: {
          settleType: [ // 结算方式
            { required: true, message: '请选择结算方式', trigger: 'blur' },
          ],
          recive: [ // 回单期限
            { validator: this.checkRecive, trigger: 'submit' },
          ],
          collection: [ // 收款期限
            { validator: this.checkCollection, trigger: 'submit' },
          ],
        },
      },
    };
  },
  methods: {

    /**
     * @param {Array} rule 规则
     * @param {String} value 当前值
     * @param {Function} call 结果执行
     * @returns {void}
     * @description 验证回单期限
     */
    checkRecive (rule, value, call) {
      const settleType = this.$refs.baseForm.getVal('settleType');
      if ((settleType === '1' || settleType === '2') && !this.otherFormData.receiptPeriod) {
        call('请输入回单期限天数');
      } else if (settleType === '3' && (!this.otherFormData.reciveMonth || !this.otherFormData.receiptPeriodDay)) {
        call('请输入回单期限天数');
      } else {
        call();
      }
    },

    /**
     * @param {Array} rule 规则
     * @param {String} value 当前值
     * @param {Function} call 结果执行
     * @returns {void}
     * @description 验证收款期限
     */
    checkCollection (rule, value, call) {
      const settleType = this.$refs.baseForm.getVal('settleType');
      if (settleType === '2' && !this.otherFormData.payPeriod) {
        call('请输入收款期限天数');
      } else if (settleType === '3' && (!this.otherFormData.collectionMonth || !this.otherFormData.payPeriodDay)) {
        call('请输入收款期限天数');
      } else {
        call();
      }
    },

    async getList () {
      const enumsData = await getEnumList({
        codeType: 'BALANCE_TYPE',
      });
      this.baseForm.settleTypeOptions = enumsData[0];
    },
    async handleLabelTypeChange () {
      const settleType = await this.$refs.baseForm.getVal('settleType');
      let isNotAuto = settleType === '1';
      const tar = ['collection'];
      // 预付全款情况下隐藏收款期限
      this.baseForm.form.forEach((item) => {
        if (tar.indexOf(item.value) !== -1) {
          item.hide = isNotAuto;
        }
      });
    },
    async cacheData () {
      let res = await this.$refs.baseForm.getVal();
      res = {
        settleType: res.settleType,
        payWay: res.settleType,
        ...this.otherFormData,
      };
      return res;
    },

    async sub () {
      let formData = await this.$refs.baseForm.sub();
      if (formData) {
        formData = {
          settleType: formData.settleType,
          payWay: formData.settleType,
          ...this.otherFormData,
        };
      }
      return formData;
    },
    async init (data = {}) {
      const res = {
        settleType: data.settleType ? String(data.settleType) : this.baseForm.settleTypeOptions[0].value,
      };
      if (data.settleType === 3) {
        data.reciveMonth = data.receiptPeriod;
        data.collectionMonth = data.payPeriod;
      }
      this.$refs.baseForm.setVal(res);
      this.setFormVal(this.otherFormData, data);
      await this.handleLabelTypeChange();
    },
  },
};
</script>

<style scoped lang="scss">
</style>
